import {DEBUG_FLAG} from './debug'

export const API_BASE_URL = DEBUG_FLAG ? 'http://127.0.0.1:20110/api/' : 'https://www.ecschool.de/api/';
